import type { ConversationConfig } from "../state/types.js";

/** Normalize the retired composer toggle without changing the wire contract. */
export function normalizeComposerFocus(
  config: Pick<ConversationConfig, "focus">,
): Exclude<ConversationConfig["focus"], "full"> {
  // Standard lets routing combine document and structured sources in Ambito.
  return config.focus === "full" ? "standard" : config.focus;
}
